import Button from 'components/button'
import React from 'react'
import textServices from 'services/text-services'
import useMainClass from 'hooks/use-main-cass'
import { ContainerAlbumPopup, DescriptionAlbumPopup, ImgAlbumPopup, TitleAlbumPopup } from '../styles/styled.components'

function AlbumPopup({ handleClick }: { handleClick: () => void }) {
  useMainClass('album__pop-up')

  return (
    <ContainerAlbumPopup className="flex-1 w-full flex flex-col gap-6 py-7 album-popup-content">
      {textServices?.findByText(
        'album/register/html',
        <div className="w-full flex flex-col gap-6 px-7 flex-1">
          <div className="flex-1 w-full flex flex-col items-center justify-center gap-6 text-center">
            <TitleAlbumPopup>
              {textServices?.findByText('album/register/title', {
                es: (
                  <>
                    CONTESTA
                    <br />Y GANA
                  </>
                ),
                en: (
                  <>
                    ANSWER
                    <br />
                    AND WIN
                  </>
                )
              })}
            </TitleAlbumPopup>
            <DescriptionAlbumPopup className="flex flex-col items-center justify-center gap-5">
              {textServices?.findByText('album/register/description', {
                es: (
                  <>
                    <b>¿Ya tienes tu ID?</b>Si no lo tienes córrele a registrarte para poder participar
                  </>
                ),
                en: (
                  <>
                    <b>Do you already have your ID?</b>If you don&apos;t have it, please register to participate.
                  </>
                )
              })}
            </DescriptionAlbumPopup>
          </div>
          <ImgAlbumPopup
            src={`${AZURE_BASE_URL}/trivia-qr-card-id.${textServices.findByText(
              'album/register/typeImage',
              'svg'
            )}`}
            alt="card id"
          />
        </div>
      )}
      <div className="w-full px-7">
        <Button onClick={handleClick}>
          {textServices?.findByText('album/register/button', { es: 'COMENCEMOS', en: 'START' })}
        </Button>
      </div>
    </ContainerAlbumPopup>
  )
}

export default AlbumPopup
